import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PopUpsService {

  constructor() { }
  
  public checkBoxCui = new BehaviorSubject(false);
  public checkBox57b = new BehaviorSubject(false);
  public checkBoxAPV = new BehaviorSubject(false);
  
}
